import type { ReactNode } from "react";
import { cn } from "@/lib/utils";
import { MintIconChip } from "./mint-icon-chip";

interface Props {
  children: ReactNode;
  title: ReactNode;
  subtitle?: ReactNode;
  footer?: ReactNode;
  className?: string;
  hideChip?: boolean;
}

export function AuthCard({ children, title, subtitle, footer, className, hideChip = false }: Props) {
  return (
    <div
      className={cn(
        "relative w-full max-w-[440px] flex flex-col items-center text-center animate-fade-up",
        className,
      )}
    >
      <h1 className="font-serif text-[44px] sm:text-[52px] leading-[1.05] tracking-tight text-ink">
        {title}
      </h1>
      {subtitle && (
        <div className="mt-9 text-[15px] text-ink-mute">{subtitle}</div>
      )}

      <div className="mt-8 flex w-full flex-col gap-4">{children}</div>

      {footer && <div className="mt-6 w-full">{footer}</div>}
    </div>
  );
}
